import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';

export default class ClientInfo extends Component {
  static propTypes = {

  };

  constructor(props)
  {
    super(props);

    //Bindings
    this.handleChangeClientCountry=this.handleChangeClientCountry.bind(this);
  }

  handleChangeClientCountry(val){
   this.props.handleChange({target:{value:val.value,id:'client_company_country'}}) 
  }
  
  getValueCountry(opts, id) {
    let realValue = opts.find(o => o.value === id);
    return realValue;
  }

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Client Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="client_company"
              name="client_company"
              label="Company"
              fullWidth
              autoComplete="pCompany"
              value={this.props.project.client_company}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.client_company}
              helperText={this.props.errores.project.client_company}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div >
              <InputLabel htmlFor="client_company_country" style={{marginRight:'10px'}}>Country</InputLabel>
              <Select
                id="client_company_country"
                name="client_company_country"
                value={this.getValueCountry(this.props.countries,this.props.project.client_company_country)}
                onChange={this.handleChangeClientCountry}
                isDisabled={this.props.reviewActive}
                error={this.props.errores.project.client_company_country}
                errorText={this.props.errores.project.client_company_country}
                helperText={this.props.errores.project.client_company_country}
                options={this.props.countries}
                styles={{control: (provided,state) => (this.props.errores.project.client_company_country ? {...provided,borderColor: 'red', } : provided)}}
              >
              </Select>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
             <TextField
              id="client_company_state"
              name="client_company_state"
              label="State"
              fullWidth
              autoComplete="pState"
              value={this.props.project.client_company_state}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.client_company_state}
              helperText={this.props.errores.project.client_company_state}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="client_company_city"
              name="client_company_city"
              label="City"
              fullWidth
              autoComplete="pCity"
              value={this.props.project.client_company_city}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.project.client_company_city}
              helperText={this.props.errores.project.client_company_city}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/ClientInfo.js